module.exports = __webpack_public_path__ + "static/season1-cover-minimal-dc0275c7e650bb17536c06e77e1ae18f.png";